module.exports = __webpack_public_path__ + "img/33@2x.dd0c4e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/33@2x.png
// module id = P7WD
// module chunks = 0